<template>
  <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
    <div
      v-for="i in count"
      :key="i"
      class="skeleton-card"
    >
      <div class="skeleton-media" />
      <div class="skeleton-body">
        <div class="skeleton-line skeleton-line--title" />
        <div class="skeleton-line skeleton-line--meta" />
      </div>
      <div class="skeleton-footer">
        <div class="skeleton-line skeleton-line--badge" />
        <div class="skeleton-line skeleton-line--icon" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
withDefaults(defineProps<{
  count?: number
}>(), {
  count: 8,
})
</script>

<style scoped>
.skeleton-card {
  @apply bg-white dark:bg-gray-800
         rounded-2xl border border-gray-200 dark:border-gray-700
         overflow-hidden;
}

.skeleton-media {
  @apply h-36 bg-gray-100 dark:bg-gray-700/50
         animate-pulse;
}

.skeleton-body {
  @apply px-4 py-3 space-y-2;
}

.skeleton-footer {
  @apply flex items-center justify-between
         px-4 py-2.5
         border-t border-gray-100 dark:border-gray-700/50;
}

.skeleton-line {
  @apply rounded-lg bg-gray-100 dark:bg-gray-700/50
         animate-pulse;
}

.skeleton-line--title {
  @apply h-4 w-3/4;
}

.skeleton-line--meta {
  @apply h-3 w-1/2;
}

.skeleton-line--badge {
  @apply h-5 w-16 rounded-full;
}

.skeleton-line--icon {
  @apply h-5 w-5 rounded-lg;
}
</style>
